import { render, staticRenderFns } from "./VDocumentCard.vue?vue&type=template&id=c3467a00"
import script from "./VDocumentCard.vue?vue&type=script&lang=js"
export * from "./VDocumentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports